/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Oauth_MicrosoftInputs */

const es_login_oauth_microsoft = /** @type {(inputs: Login_Oauth_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

const en_login_oauth_microsoft = /** @type {(inputs: Login_Oauth_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft`)
};

/**
* | output |
* | --- |
* | "Microsoft" |
*
* @param {Login_Oauth_MicrosoftInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_oauth_microsoft = /** @type {((inputs?: Login_Oauth_MicrosoftInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Oauth_MicrosoftInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_oauth_microsoft(inputs)
	return en_login_oauth_microsoft(inputs)
});
export { login_oauth_microsoft as "login.oauth.microsoft" }